
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dla-samorzadu",
      function () {
        return require("private-next-pages/dla-samorzadu/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dla-samorzadu"])
      });
    }
  